import { Platform } from '@angular/cdk/platform';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent, MatPaginator } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, skip } from 'rxjs/operators';
import { MyBusinessDataSource } from '../datasource/mybusiness.datasource';
import { BusinessService } from './../services/business.service';
import { MybusinessRejectDialogComponent } from './mybusiness-reject-dialog/mybusiness-reject-dialog.component';
import { MybusinessViewDialogComponent } from './mybusiness-view-dialog/mybusiness-view-dialog.component';
declare var $: any;
@Component({
  selector: 'app-my-business',
  templateUrl: './my-business.component.html',
  styleUrls: ['./my-business.component.css'],
  providers: [DatePipe]
})
export class MyBusinessComponent implements OnInit {
  dataSource: MyBusinessDataSource
  displayedColumns: string[] = ['createddate', 'companyname', 'contactperson', 'transactionvalue', 'percentage', 'referralreward', 'paymentstatus', 'details'];
  isMobile: boolean = false;
  isloading: boolean = false;
  private subscriptions: Subscription[] = [];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  businessFilterList = {
    userId: '',
    from: 1,
    to: 10,
    search: '',
    fromDate: '',
    toDate: '',
    paymentStatusId: ''
  }
  businessResult: any[];
  dashboardRecord: any;
  filterForm: FormGroup;
  currentUser: any;
  current: Date = new Date();
  showError: boolean = false;
  Fromdate: Date;
  public paymentStatusList = [
    { value: 1, viewValue: 'Pending' },
    { value: 2, viewValue: 'Approved' },
    { value: 3, viewValue: 'Rejected' },
  ];
  paymentStatusValue: any;
  currentUserData: any;
  statusName = [];
  constructor(private mybusinessService: BusinessService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private chRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private _cookieService: CookieService,
    private toastr: ToastrService,
    private router: Router,
    private http: HttpClient,
    public platform: Platform
  ) { }
  ngOnInit() {
    this.isMobile = this.platform.ANDROID || this.platform.IOS;
    this.currentUser = JSON.parse(localStorage.getItem('responseData'));
    this.currentUserData = JSON.parse(localStorage.getItem('userDetails'));
    this.createFilterForm();
    this.dataSource = new MyBusinessDataSource(this.mybusinessService);
    const entitiesSubscription = this.dataSource.entitySubject.pipe(
      skip(1),
      distinctUntilChanged()
    ).subscribe(res => {
      this.businessResult = res;
    });
    this.getDashboard();
    this.dataSource.loadMybusiness(this.businessFilterList);
    this.subscriptions.push(entitiesSubscription);
  }
  createFilterForm() {
    this.filterForm = this.fb.group({
      paymentStatusId: [''],
      FromDate: [''],
      ToDate: [''],
    });
  }
  ngAfterViewInit() {
    const searchSubscription = fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(() => {
      this.paginator.pageIndex = 0;
      this.loadmybusinessPage();
    });
    this.subscriptions.push(searchSubscription);
    const paginatorSubscriptions = this.paginator.page.subscribe(() => {
      this.loadmybusinessPage();
    });
    this.subscriptions.push(paginatorSubscriptions);
  }
  loadmybusinessPage() {
    if (this.paginator.pageIndex < 0 || this.paginator.pageIndex > (this.paginator.length / this.paginator.pageSize))
      return;
    this.businessFilterList.from = ((this.paginator.pageIndex * this.paginator.pageSize) + 1);
    this.businessFilterList.to = this.paginator.pageSize;
    this.businessFilterList.search = this.searchInput.nativeElement.value;
    this.dataSource.loadMybusiness(this.businessFilterList);
    this.chRef.detectChanges();
  }
  getDashboard() {
    const dashboardSubscription = this.dataSource.dasboardRecord.subscribe(res => {
      this.dashboardRecord = res;
    });
    this.subscriptions.push(dashboardSubscription);
  }
  viewRejectedReason(reason) {
    this.dialog.open(MybusinessRejectDialogComponent, { data: reason, width: '400px' });
  }
  view(element) {
    const params = {
      companyName: element.leadName,
      transactionValue: element.transactionValue,
      createdDate: element.createdDate
    }
    const dialogRef = this.dialog.open(MybusinessViewDialogComponent, { data: params, width: '900px' });
  }
  applyFilter() {
    const filterControl = this.filterForm.controls;
    const filterControlForChip = this.filterForm.controls;
    if (filterControl['paymentStatusId'].value) {
      this.businessFilterList.paymentStatusId = filterControl['paymentStatusId'].value.map(e => e.value).toString();
    } else {
      this.businessFilterList.paymentStatusId = '';
    }
    this.businessFilterList.fromDate = this.datePipe.transform(filterControl['FromDate'].value, 'yyyy-MM-dd');
    this.businessFilterList.toDate = this.datePipe.transform(filterControl['ToDate'].value, 'yyyy-MM-dd');
    this.dataSource.loadMybusiness(this.businessFilterList);
  }
  clearFilters() {
    this.businessFilterList.paymentStatusId = ''
    this.businessFilterList.fromDate = ''
    this.businessFilterList.toDate = ''
    this.dataSource.loadMybusiness(this.businessFilterList);
    this.filterForm.reset();
  }
  restrict(event: MatDatepickerInputEvent<Date>) {
    this.Fromdate = event.value;
    if (this.filterForm.controls['FromDate'].touched) {
      this.filterForm.controls['ToDate'].setValidators(Validators.required);
      this.filterForm.controls['ToDate'].updateValueAndValidity();
      this.showError = true;
    }
    if (this.filterForm.controls['ToDate'].value) {
      this.showError = false;
    }
  }
  export() {
    this.isloading = true;
    this.mybusinessService.fileExport(this.businessFilterList).subscribe({
      next: (res) => {
        this.isloading = false;
        if (!res) return this.toastr.error("Invalid response from server.");
        this.toastr.success("File generated successfully");
        // this.toastr[res.Status === 200 ? 'success' : 'error'](
        //   res.Status === 200 ? "File generated successfully." : `Unexpected response: ${res.Status}`
        // );
      },
      error: (err) => {
        this.isloading = false;
        this.toastr.error("Something went wrong.", err.message);
      }, 
    });
  }
}
